// hooks/useWhatsappActivityListData.ts
import { getAiServiced } from '@api/services/analytics.service';
import useDataQuery from '@hooks/use-data-query';
import { useMemo } from 'react';

const useAiActivityListData = () => {
    const query = useDataQuery(['ai-activity'], () => getAiServiced());

    const data = useMemo(() => query.data || [], [query.data]);

    return {
        data,
        isLoading: query.isLoading,
    };
};

export default useAiActivityListData;
